
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * SVG
         */
        const tabActive = ref<string>('variant5');
        const tabs: string[] = ['variant5'];
        const noImage = 'delta';

        function activeTab (tab: string): void {
            tabActive.value = tab;
        }

		return { endpointId, tabs, activeTab, tabActive, noImage }
	}

    export default defineComponent({
    setup() {
        return { ...bespokeComposition() };
    }
})
